import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const ChevronRight = RESIDENTS_SVG_COMPONENTS.CHEVRON_RIGHT;

interface PaymentOptionButtonProps {
  label: string;
  onPress: () => void;
  disabled?: boolean;
}

/**
 * Reusable option button with chevron icon
 * Used in AddPaymentMethodContent and ChangePaymentMethodContent
 */
export const PaymentOptionButton: React.FC<PaymentOptionButtonProps> = ({
  label,
  onPress,
  disabled = false,
}) => {
  return (
    <TouchableOpacity
      style={[styles.optionButton, disabled && styles.optionButtonDisabled]}
      onPress={onPress}
      activeOpacity={0.8}
      disabled={disabled}
    >
      <Text style={[styles.optionText, disabled && styles.optionTextDisabled]}>
        {label}
      </Text>
      <View style={styles.optionRight}>
        {ChevronRight && (
          <ChevronRight
            width={24}
            height={24}
            color={disabled ? MARKETPLACE_COLORS.textMuted : MARKETPLACE_COLORS.textPrimary}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  optionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 40,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.textPrimary,
    borderRadius: 8,
  },
  optionButtonDisabled: {
    borderColor: MARKETPLACE_COLORS.inputBorder,
    opacity: 0.6,
  },
  optionText: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  optionTextDisabled: {
    color: MARKETPLACE_COLORS.textMuted,
  },
  optionRight: {
    width: 28,
    height: 24,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
});

export default PaymentOptionButton;
